module.exports = __webpack_public_path__ + "img/produto-doces.051f9d7c.png";